import React, {createContext} from 'react'
export const ComponentsContext = createContext({})
